export interface companyDataViewModel {
    companyId: string;
    insuranceId: string;
    companyName: string;
}

export const companyData: companyDataViewModel[] = [
    {
        companyId: '229a8f96-2d04-41c7-b498-ae8698690066',
        insuranceId: 'abe47478-b648-41e3-a456-9a8980635abc',
        companyName: 'Seguradora Sura'
    }
];
